import * as d3Shape from "@mui/x-charts-vendor/d3-shape";
import * as React from "react";
import { ChartsReferenceLine } from "@mui/x-charts/ChartsReferenceLine";
import { useLineSeries, useXAxis, useXScale, useYScale } from "@mui/x-charts/hooks";

export function UncertaintyArea({ lower, upper, color }) {
  const lineSeries = useLineSeries();
  const xAxis = useXAxis();
  const xScale = useXScale();
  const yScale = useYScale();
  const xAxisData = xAxis.data;

  if (!yScale) {
    return null;
  }

  return (
    <React.Fragment>
      {lineSeries.map((series) => {
        const data = xAxisData.map((v, i) => ({
          x: v,
          y0: lower[i],
          y1: upper[i],
        }));

        const path = d3Shape
          .area()
          .x((d) => xScale(d.x))
          .y0((d) => yScale(d.y0))
          .y1((d) => yScale(d.y1))(data);

        return <path key={`forecast-area-${series.id}`} d={path} fill={color} />;
      })}
    </React.Fragment>
  );
}

export function DayLines({ midnight, current_time }) {
  return (
    <>
      <ChartsReferenceLine x={midnight[0]} lineStyle={{ stroke: "#555555ff" }} />
      <ChartsReferenceLine x={midnight[1]} lineStyle={{ stroke: "#555555ff" }} />
      <ChartsReferenceLine x={midnight[2]} lineStyle={{ stroke: "#555555ff" }} />
      <ChartsReferenceLine x={midnight[3]} lineStyle={{ stroke: "#555555ff" }} />
      <ChartsReferenceLine x={midnight.at(-1)} lineStyle={{ stroke: "#555555ff" }} />
      <ChartsReferenceLine
        x={current_time}
        lineStyle={{
          strokeDasharray: "10 5",
          stroke: "#e90f0fff",
          strokeWidth: "2",
        }}
        // label={'Now'}
        labelAlign={"start"}
      />
    </>
  );
}
